import { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { EventMemberPicker } from './EventMemberPicker';

export const EventInviteDialog = ({ event, onClose, onInvited }) => {
  const [selected, setSelected] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const lock = useRef(false);
  const send = async () => {
    if (lock.current || !selected.length) return;
    lock.current = true; setBusy(true); setError('');
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/social-events/${event.event_id}/invite`, selected.map(m => m.user_id));
      onInvited(data);
      toast.success(data.notification_delivery?.pending_count ? 'Members added. Some notifications need a retry.' : 'Invitations sent.');
      onClose();
    } catch (err) { setError(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Could not send invitations. Please retry.'); }
    finally { lock.current = false; setBusy(false); }
  };
  return <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
    <DialogContent className="ps-themed-dialog space-y-4 bg-[var(--ps-bg-surface)] text-[var(--ps-text-primary)] border-[var(--ps-border)] max-w-lg max-h-[90dvh] overflow-y-auto" data-testid="event-invite-dialog">
      <DialogHeader><DialogTitle data-testid="event-invite-title">Invite members</DialogTitle><DialogDescription className="break-words" data-testid="event-invite-event-title">{event.title}</DialogDescription></DialogHeader>
      <EventMemberPicker selected={selected} onChange={setSelected} excludeIds={event.participants.map(p => p.user_id)} disabled={busy} />
      {error && <p role="alert" className="text-sm text-red-500" data-testid="event-invite-error">{error}</p>}
      <div className="flex flex-wrap justify-end gap-2">
        <Button type="button" variant="ghost" disabled={busy} onClick={onClose} data-testid="event-invite-cancel">Cancel</Button>
        <Button type="button" className="dark-btn-primary" disabled={busy || !selected.length} onClick={send} data-testid="event-invite-send"><Send size={16} className="mr-2" />{busy ? 'Sending…' : 'Send invitations'}</Button>
      </div>
    </DialogContent>
  </Dialog>;
};